var map = {
	"./icon-filter-ing.png": "UOX1",
	"./icon-filter.png": "aR8M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NR3l";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train ^\.\/icon\-filter.*\.png$
// module id = NR3l
// module chunks = 1